// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__22SPo","active":"NavigationItem_active__3mBqn"};